module.exports = __webpack_public_path__ + "img/background-9.57ab4e0a.jpg";